import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { TIMEOUT } from "src/global";
import { IBaseState } from "src/interfaces";
import { INetElectricityProps } from "./interfaces";

export default class NetElectricity extends Component<INetElectricityProps, IBaseState> {
  public constructor(props: INetElectricityProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset className="fieldset-right">
          <legend>Net Electricity</legend>
          <LoadingStatus width={25} height={25} singular={true} type="Watch" />
        </fieldset>
      );
    }

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 5;
    const smInputWidthR = 7;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    const readOnly = this.props.match.params.priorId !== undefined;

    let netOnPeakGridUsage =
      this.props.onPeakGridUsage - this.props.onPeakSolarCredited - this.props.onPeakSolarCredits;
    if (isNaN(netOnPeakGridUsage)) {
      netOnPeakGridUsage = 0;
    }
    let netOffPeakGridUsage =
      this.props.offPeakGridUsage -
      this.props.offPeakSolarCredited -
      this.props.offPeakSolarCredits;
    if (isNaN(netOffPeakGridUsage)) {
      netOffPeakGridUsage = 0;
    }

    return (
      <fieldset className="fieldset-right">
        <legend>Net Electricity</legend>
        <FormGroup bsSize="small" controlId="totalDelivered">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Total from Grid
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.totalElectricityFromGrid}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakGridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Usage
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.onPeakGridUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakSolarCredited">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Credited
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.onPeakSolarCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="onPeakSolarCredits">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            On-peak Credits
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.onPeakSolarCredits}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.onPeakSolarCreditsChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="netOnPeakGridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Net On-Peak Usage
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={netOnPeakGridUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="offPeakGridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Off-peak Usage
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.offPeakGridUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="offPeakSolarCredited">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Off-peak Credited
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.offPeakSolarCredited}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="offPeakSolarCredits">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Off-peak Credits
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.offPeakSolarCredits}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.props.offPeakSolarCreditsChanged}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="netOffPeakGridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Net Off-peak Usage
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={netOffPeakGridUsage}
              tabIndex={-1}
              readOnly={true}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/dualrate/NetElectricity.tsx